<template>
  <div class="relative">
    <img :src="baseImg" alt="device base" draggable="false" />

    <!-- 灯带 -->
    <div
      class="light-strip absolute inset-0 transition-all duration-300"
      :style="{
        maskImage: `url('${lightStripImg}')`,
        '-webkit-mask-image': `url('${lightStripImg}')`,
        ...(enabledLighting ? bandLightStyles : { background: 'transparent' }),
      }"
      aria-hidden="true"
    />

    <!-- 铭牌灯 -->
    <div
      v-if="hasBrandLight"
      class="light-brand absolute inset-0"
      :style="{
        maskImage: `url('${lightBrandImg}')`,
        '-webkit-mask-image': `url('${lightBrandImg}')`,
        ...screenLightStyles,
      }"
      aria-hidden="true"
    />
  </div>
</template>

<script setup lang="ts">
  import { useDeviceStore } from '@/stores'
  import { getImageUrl } from '@/utils/assets'
  import { storeToRefs } from 'pinia'
  import { computed, CSSProperties } from 'vue'

  defineProps<{
    hasBrandLight: boolean
    bandLightStyles: CSSProperties
    screenLightStyles: CSSProperties
    enabledLighting: boolean
  }>()

  const deviceStore = useDeviceStore()
  const { currentDevice } = storeToRefs(deviceStore)

  const assetsDir = computed(() => currentDevice.value?.manifest.ui.assetsDir)
  const baseImg = computed(() => getImageUrl(assetsDir.value + '/func_base.png'))
  const lightStripImg = computed(() => getImageUrl(assetsDir.value + '/func_light.png'))
  const lightBrandImg = computed(() => getImageUrl(assetsDir.value + '/func_logo.png'))
</script>

<style scoped>
  .light-strip {
    -webkit-mask-mode: luminance;
    mask-mode: luminance;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-size: contain;
    mask-size: contain;
  }

  .light-brand {
    -webkit-mask-mode: luminance;
    mask-mode: luminance;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-size: contain;
    mask-size: contain;
  }

  .animate-breathe {
    animation: breathe 3s ease-in-out infinite;
  }
  .animate-flow {
    background-size: 200% 100%;
    animation: flow 4s linear infinite;
  }
</style>

<style>
  @keyframes breathe {
    0%,
    100% {
      opacity: 0.1;
      filter: brightness(0.4);
    }
    50% {
      opacity: 1;
      filter: brightness(1.3) drop-shadow(0 0 6px currentColor);
    }
  }
  @keyframes flow {
    to {
      background-position: 200% 0;
    }
  }
  @keyframes flow-vertical {
    to {
      background-position: 0 200%;
    }
  }
  @keyframes colorCycle {
    0% {
      background-color: #ff0000;
    }
    12.5% {
      background-color: #ff3d01;
    }
    25% {
      background-color: #ffcb00;
    }
    37.5% {
      background-color: #83ff01;
    }
    50% {
      background-color: #01ff71;
    }
    62.5% {
      background-color: #01fca5;
    }
    75% {
      background-color: #01e2f0;
    }
    87.5% {
      background-color: #01b7ff;
    }
    100% {
      background-color: #ff0000;
    }
  }
</style>
